import type { IMetadata } from '@adloid-technologies/discover-sdk';

/**
 * Cadillac Escalade IQ (linkId 2374, project 59).
 *
 * Converted from the 1.0 repo's `src/metadata/data/metadata-2374.ts`
 * (`appData.visualiser.models[0]`, array-shaped) into the 2.0 object-keyed
 * `IMetadata` shape, following the conventions established for 2382/2377:
 * consolidate-or-split fingerprinting per entity, `autoIntelRPOCode` from
 * `brandItemCode`, real condition/isDefault/isStop threading on accessory
 * messages, model-level `hotspots` built from the default variant, and
 * `groupId`/`isDefault` derived from `removeAccessories` via connected
 * components (with single-select group categories normalised to the group's
 * dominant category — 1.0 sometimes mislabels one member).
 *
 * Pricing: 1.0 ships all-zero pricing for every variant
 * (showPrice:false in 1.0's own presentation config), same as Sierra LD -
 * featureFlags.showPrices is off and specifications.price is left blank
 * rather than showing "Starting from 0 MSRP".
 *
 * Generated — see the conversion notes in ui-metadata.ts.
 */
export const metadata: IMetadata = {
  models: {
    EscaladeIQ: {
      id: 'EscaladeIQ',
      lightingIdentifier: {
        interior: 'dome',
        exterior: 'dome',
      },
      postProcessingIdentifier: {
        interior: 'dome',
        exterior: 'dome',
      },
      backgroundIdentifer: 'dome',
      variants: {
        luxury: {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5631',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'exterior-color',
              sku: '5634',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'interior-color',
              sku: '5638',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'dome',
              sku: '5525',
              projectId: '59',
              position: [0, 0, 0],
              maxResolution: {
                ios: '2K',
                android: '4K',
              },
            },
            {
              id: 'variants_parts',
              sku: '5643',
              projectId: '59',
              position: [0, 0, 0],
            },
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color',
        },
        'premium-luxury': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5631',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'exterior-color',
              sku: '5634',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'interior-color',
              sku: '5640',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'dome',
              sku: '5525',
              projectId: '59',
              position: [0, 0, 0],
              maxResolution: {
                ios: '2K',
                android: '4K',
              },
            },
            {
              id: 'variants_parts',
              sku: '5649',
              projectId: '59',
              position: [0, 0, 0],
            },
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color',
        },
        sport: {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5631',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'exterior-color',
              sku: '5634',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'interior-color',
              sku: '5638',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'dome',
              sku: '5525',
              projectId: '59',
              position: [0, 0, 0],
              maxResolution: {
                ios: '2K',
                android: '4K',
              },
            },
            {
              id: 'variants_parts',
              sku: '5627',
              projectId: '59',
              position: [0, 0, 0],
            },
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color',
        },
        'premium-sport': {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5631',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'exterior-color',
              sku: '5634',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'interior-color',
              sku: '5640',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'dome',
              sku: '5525',
              projectId: '59',
              position: [0, 0, 0],
              maxResolution: {
                ios: '2K',
                android: '4K',
              },
            },
            {
              id: 'variants_parts',
              sku: '5625',
              projectId: '59',
              position: [0, 0, 0],
            },
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color',
        },
      },
      backgrounds: {
        g0ZA968_RpUd: {
          isDefault: true,
          sku: '5525',
          project: '59',
        },
        g0ZA968_RpUe: {
          isDefault: false,
          sku: '5457',
          project: '59',
        },
      },
      ambientLighting: {
        ambientColors: '#ff1300,#0040FF,#ff9f51,#aafef4,#00b6ff,#61ff87',
        ambientLightings: {
          ambientRed: {
            isDefault: true,
            identifier: 'interior-color',
            variantIdentifiers: {
              luxury: 'interior-color',
              'premium-luxury': 'interior-color',
              sport: 'interior-color',
              'premium-sport': 'interior-color',
            },
            materialName: [
              'INT_AMBIENT_GLOW',
              'INT_AMBIENT_02_GLOW',
              'INT_DOOR_AMBIENT_LIGHT',
            ],
            parentNodeName: [],
            emissiveColor: [255, 19, 0],
            emissiveIntensity: 0.5,
          },
          ambientBlue: {
            isDefault: false,
            identifier: 'interior-color',
            variantIdentifiers: {
              luxury: 'interior-color',
              'premium-luxury': 'interior-color',
              sport: 'interior-color',
              'premium-sport': 'interior-color',
            },
            materialName: [
              'INT_AMBIENT_GLOW',
              'INT_AMBIENT_02_GLOW',
              'INT_DOOR_AMBIENT_LIGHT',
            ],
            parentNodeName: [],
            emissiveColor: [0, 64, 255],
            emissiveIntensity: 0.5,
          },
          ambientOrange: {
            isDefault: false,
            identifier: 'interior-color',
            variantIdentifiers: {
              luxury: 'interior-color',
              'premium-luxury': 'interior-color',
              sport: 'interior-color',
              'premium-sport': 'interior-color',
            },
            materialName: [
              'INT_AMBIENT_GLOW',
              'INT_AMBIENT_02_GLOW',
              'INT_DOOR_AMBIENT_LIGHT',
            ],
            parentNodeName: [],
            emissiveColor: [255, 159, 81],
            emissiveIntensity: 0.5,
          },
          ambientCyan: {
            isDefault: false,
            identifier: 'interior-color',
            variantIdentifiers: {
              luxury: 'interior-color',
              'premium-luxury': 'interior-color',
              sport: 'interior-color',
              'premium-sport': 'interior-color',
            },
            materialName: [
              'INT_AMBIENT_GLOW',
              'INT_AMBIENT_02_GLOW',
              'INT_DOOR_AMBIENT_LIGHT',
            ],
            parentNodeName: [],
            emissiveColor: [170, 254, 244],
            emissiveIntensity: 0.5,
          },
          ambientSkyBlue: {
            isDefault: false,
            identifier: 'interior-color',
            variantIdentifiers: {
              luxury: 'interior-color',
              'premium-luxury': 'interior-color',
              sport: 'interior-color',
              'premium-sport': 'interior-color',
            },
            materialName: [
              'INT_AMBIENT_GLOW',
              'INT_AMBIENT_02_GLOW',
              'INT_DOOR_AMBIENT_LIGHT',
            ],
            parentNodeName: [],
            emissiveColor: [0, 182, 255],
            emissiveIntensity: 0.5,
          },
          ambientGreen: {
            isDefault: false,
            identifier: 'interior-color',
            variantIdentifiers: {
              luxury: 'interior-color',
              'premium-luxury': 'interior-color',
              sport: 'interior-color',
              'premium-sport': 'interior-color',
            },
            materialName: [
              'INT_AMBIENT_GLOW',
              'INT_AMBIENT_02_GLOW',
              'INT_DOOR_AMBIENT_LIGHT',
            ],
            parentNodeName: [],
            emissiveColor: [97, 255, 135],
            emissiveIntensity: 0.5,
          },
        },
        relevantVariants: ['luxury', 'premium-luxury', 'sport', 'premium-sport'],
      },
      colors: {
        exterior: {
          hdylxnq5ongg: {
            sku: '5624',
            project: '59',
            relevantVariants: [
              'luxury',
            ],
          },
          z60gu7myefcq: {
            sku: '5634',
            project: '59',
            relevantVariants: [
              'luxury',
            ],
          },
          pyseql4zovea: {
            sku: '5633',
            project: '59',
            relevantVariants: [
              'luxury',
            ],
          },
          grtuz3xrjvjx: {
            sku: '5636',
            project: '59',
            relevantVariants: [
              'luxury',
            ],
          },
          q4qmk6bmi8xz: {
            sku: '5646',
            project: '59',
            relevantVariants: [
              'luxury',
            ],
          },
          '2jma8j7wwsg1': {
            sku: '5632',
            project: '59',
            relevantVariants: [
              'luxury',
            ],
          },
          z0dyjanuh8ez: {
            sku: '5624',
            project: '59',
            relevantVariants: [
              'premium-luxury',
            ],
          },
          xoy24l8txfrw: {
            sku: '5634',
            project: '59',
            relevantVariants: [
              'premium-luxury',
            ],
          },
          ulowkyk9i8l3: {
            sku: '5633',
            project: '59',
            relevantVariants: [
              'premium-luxury',
            ],
          },
          l33t4kmkku9z: {
            sku: '5636',
            project: '59',
            relevantVariants: [
              'premium-luxury',
            ],
          },
          zydt6r4wfd05: {
            sku: '5646',
            project: '59',
            relevantVariants: [
              'premium-luxury',
            ],
          },
          l1i85v9uhdfv: {
            sku: '5632',
            project: '59',
            relevantVariants: [
              'premium-luxury',
            ],
          },
          '0ok038kswmfd': {
            sku: '5624',
            project: '59',
            relevantVariants: [
              'sport',
            ],
          },
          yxw2frp46hgw: {
            sku: '5634',
            project: '59',
            relevantVariants: [
              'sport',
            ],
          },
          asxomtrg9w1c: {
            sku: '5633',
            project: '59',
            relevantVariants: [
              'sport',
            ],
          },
          '6u9gt5w3ckly': {
            sku: '5636',
            project: '59',
            relevantVariants: [
              'sport',
            ],
          },
          yz66c0tiy5od: {
            sku: '5646',
            project: '59',
            relevantVariants: [
              'sport',
            ],
          },
          yrw5q87qr1m2: {
            sku: '5632',
            project: '59',
            relevantVariants: [
              'sport',
            ],
          },
          bxh465tzzs6q: {
            sku: '5628',
            project: '59',
            relevantVariants: [
              'sport',
            ],
          },
          '4f9dd3vca75z': {
            sku: '5624',
            project: '59',
            relevantVariants: [
              'premium-sport',
            ],
          },
          '69xux2hlscm1': {
            sku: '5634',
            project: '59',
            relevantVariants: [
              'premium-sport',
            ],
          },
          '0pazineb3kjj': {
            sku: '5633',
            project: '59',
            relevantVariants: [
              'premium-sport',
            ],
          },
          qzewltf6e2pf: {
            sku: '5636',
            project: '59',
            relevantVariants: [
              'premium-sport',
            ],
          },
          '10xy9i682nxc': {
            sku: '5646',
            project: '59',
            relevantVariants: [
              'premium-sport',
            ],
          },
          '37wp0lpjh309': {
            sku: '5632',
            project: '59',
            relevantVariants: [
              'premium-sport',
            ],
          },
          '37wp0lpjh3099': {
            sku: '5628',
            project: '59',
            relevantVariants: [
              'premium-sport',
            ],
          },
        },
        interior: {
          ia3nfdhs8c03: {
            sku: '5638',
            project: '59',
            relevantVariants: [
              'luxury',
            ],
            notCompatibleExteriorColors: [],
            // Close the door before the new interior material swaps in - it
            // wasn't authored against an open-door pose.
            affectedInteractionOnApply: {
              ihmz2ch7lru2: { add: false, snapToLastFrame: true },
            },
          },
          o9uwhc43s6fh: {
            sku: '5637',
            project: '59',
            relevantVariants: [
              'luxury',
            ],
            notCompatibleExteriorColors: [],
            affectedInteractionOnApply: {
              ihmz2ch7lru2: { add: false, snapToLastFrame: true },
            },
          },
          immenmu3osg3: {
            sku: '5640',
            project: '59',
            relevantVariants: [
              'premium-luxury',
            ],
            notCompatibleExteriorColors: [],
            // Same Executive Pack (2nd row seat) gap as premium-sport below -
            // gnrq06v7wp8x/u3aqo2hqpc6a's applyMessages pick between
            // Camelia/Harbor Blue via condition, but that's only evaluated
            // when the accessory's own messages are (re)dispatched.
            accessoriesToReload: ['gnrq06v7wp8x', 'u3aqo2hqpc6a'],
            affectedInteractionOnApply: {
              pdvesjvy4q3c: { add: false, snapToLastFrame: true },
            },
          },
          d5qwcahyus4l: {
            sku: '5626',
            project: '59',
            relevantVariants: [
              'premium-luxury',
            ],
            notCompatibleExteriorColors: [],
            accessoriesToReload: ['gnrq06v7wp8x', 'u3aqo2hqpc6a'],
            affectedInteractionOnApply: {
              pdvesjvy4q3c: { add: false, snapToLastFrame: true },
            },
          },
          lz9ceu2ilwoy: {
            sku: '5638',
            project: '59',
            relevantVariants: [
              'sport',
            ],
            notCompatibleExteriorColors: [],
            affectedInteractionOnApply: {
              nsrbl8k7p41m: { add: false, snapToLastFrame: true },
            },
          },
          i5bekdchyela: {
            sku: '5637',
            project: '59',
            relevantVariants: [
              'sport',
            ],
            notCompatibleExteriorColors: [],
            affectedInteractionOnApply: {
              nsrbl8k7p41m: { add: false, snapToLastFrame: true },
            },
          },
          '1c0z0wtq7ikc': {
            sku: '5640',
            project: '59',
            relevantVariants: [
              'premium-sport',
            ],
            notCompatibleExteriorColors: [],
            // The Executive Pack (2nd row seat) accessory's applyMessages
            // pick between Camelia/Harbor Blue via a `(sku) is (interior-color)`
            // condition, but that condition is only evaluated when the
            // accessory's own messages are (re)dispatched - a later interior
            // color change doesn't retrigger it on its own, leaving the seat
            // stuck on whichever color was active at variant load. Reload
            // whichever of the group is currently active so it re-evaluates.
            accessoriesToReload: ['wtnujr9hlztg', 'az7g6geux1c2'],
            affectedInteractionOnApply: {
              f6mckp6y4528: { add: false, snapToLastFrame: true },
            },
          },
          '0rl5mcxrsw1t': {
            sku: '5626',
            project: '59',
            relevantVariants: [
              'premium-sport',
            ],
            notCompatibleExteriorColors: [],
            accessoriesToReload: ['wtnujr9hlztg', 'az7g6geux1c2'],
            affectedInteractionOnApply: {
              f6mckp6y4528: { add: false, snapToLastFrame: true },
            },
          },
        },
      },
      features: {
        '5pgoz7t60v6h': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'luxury',
          ],
          messages: [
            {
              message: 'Exterior Design',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '6jwn13j18qd6': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'luxury',
          ],
          messages: [
            {
              message: 'SHADER_Front_grille',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Front grille',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        s3bl9flf84yy: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'luxury',
          ],
          messages: [
            {
              message: 'SHADER_Wheel',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Wheels',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        z7f5dg1363j7: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'luxury',
          ],
          messages: [
            {
              message: 'SHADER_Info_screen',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Infotainment screen',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        gilc1wkl093x: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'luxury',
          ],
          messages: [
            {
              message: 'Sound System',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        k89m8cufzlmf: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'luxury',
          ],
          messages: [
            {
              message: 'Transmisson Screen',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'SHADER_Transmisson_screen',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        k9kcgg3ekptk: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'luxury',
          ],
          messages: [
            {
              message: 'Ambient Lighting',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        limkmbko6ukv: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'luxury',
          ],
          messages: [
            {
              message: 'AC Vents',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        palz11dc7i8g: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'premium-luxury',
          ],
          messages: [
            {
              message: 'Exterior Design',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        hvl07w5yuc7w: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'premium-luxury',
          ],
          messages: [
            {
              message: 'SHADER_Front_grille',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Front grille',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        uz3ja22iudrt: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'premium-luxury',
          ],
          messages: [
            {
              message: 'SHADER_Wheel',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Wheels',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        k47zzp6rkwct: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'premium-luxury',
          ],
          messages: [
            {
              message: 'SHADER_Info_screen',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Infotainment screen',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        br1o4haus32j: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'premium-luxury',
          ],
          messages: [
            {
              message: 'Sound System',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        gy96py28zcyg: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'premium-luxury',
          ],
          messages: [
            {
              message: 'Transmisson Screen',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'SHADER_Transmisson_screen',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        g3pasrhugsxy: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'premium-luxury',
          ],
          messages: [
            {
              message: 'Ambient Lighting',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        aohmqq9vt0vr: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'premium-luxury',
          ],
          messages: [
            {
              message: 'AC Vents',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        r3smobkiwrrx: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'sport',
          ],
          messages: [
            {
              message: 'Exterior Design',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '0jwb6s4t5liv': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'sport',
          ],
          messages: [
            {
              message: 'SHADER_Front_grille',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Front grille',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        fpwix2qmqkw4: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'sport',
          ],
          messages: [
            {
              message: 'SHADER_Wheel',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Wheels',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        e9qp6nnv5f19: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'sport',
          ],
          messages: [
            {
              message: 'SHADER_Info_screen',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Infotainment screen',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        wsz8et9j4val: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'sport',
          ],
          messages: [
            {
              message: 'Sound System',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        qg5s843osgr8: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'sport',
          ],
          messages: [
            {
              message: 'Transmisson Screen',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'SHADER_Transmisson_screen',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        e91e6sdviyij: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'sport',
          ],
          messages: [
            {
              message: 'Ambient Lighting',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        wwgrqr1m9kn4: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'sport',
          ],
          messages: [
            {
              message: 'AC Vents',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '0gvs8s0ln4fh': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'premium-sport',
          ],
          messages: [
            {
              message: 'Exterior Design',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        nb8tkmndj3vg: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'premium-sport',
          ],
          messages: [
            {
              message: 'SHADER_Front_grille',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Front grille',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        m37v8o8yl5x2: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: [
            'premium-sport',
          ],
          messages: [
            {
              message: 'SHADER_Wheel',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Wheels',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        xogfbqwjubb0: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'premium-sport',
          ],
          messages: [
            {
              message: 'SHADER_Info_screen',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'Infotainment screen',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        s4f98dj7g3mk: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'premium-sport',
          ],
          messages: [
            {
              message: 'Sound System',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        epg4m463go0z: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'premium-sport',
          ],
          messages: [
            {
              message: 'Transmisson Screen',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'SHADER_Transmisson_screen',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        tvh5xpuhzsbz: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'premium-sport',
          ],
          messages: [
            {
              message: 'Ambient Lighting',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        ngzrs5lwkgop: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: [
            'premium-sport',
          ],
          messages: [
            {
              message: 'AC Vents',
              identifiers: [
                'common_exterior',
              ],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
      },
      accessories: {
        gffn6s182da2: {
          view: 'exterior',
          groupId: 'luxury-g0',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'WO_Seat_Display_Sheer_Gray',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SEAT_SCREEN',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_SEAT_DISPLAY',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'luxury',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        f2a1kj98at78: {
          view: 'interior',
          groupId: 'luxury-g0',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_Seat_Display_Sheer_Gray',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SEAT_SCREEN',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_SEAT_DISPLAY',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'luxury',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        m639a7vzbuw2: {
          view: 'exterior',
          groupId: 'luxury-g1',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'EXT_Roof',
              identifiers: [
                'exterior-color',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ROOF',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'luxury',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        fbyp03faxepb: {
          view: 'exterior',
          groupId: 'luxury-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'EXT_Black_Roof',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ROOF',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'luxury',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        gnrq06v7wp8x: {
          view: 'exterior',
          groupId: 'premium-luxury-g0',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'WO_Executive_Pack_Camelia_Backen',
              identifiers: [
                'common_exterior',
              ],
              condition: '(5640) is (interior-color)',
              isDefault: true,
              isStop: false,
            },
            {
              message: 'WO_Executive_Pack_Harbor_Blue',
              identifiers: [
                'common_exterior',
              ],
              condition: '(5626) is (interior-color)',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premium-luxury',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        u3aqo2hqpc6a: {
          view: 'interior',
          groupId: 'premium-luxury-g0',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_Executive_Pack_Camelia_Backen',
              identifiers: [
                'common_exterior',
              ],
              condition: '(5640) is (interior-color)',
              isDefault: true,
              isStop: false,
            },
            {
              message: 'W_Executive_Pack_Harbor_Blue',
              identifiers: [
                'common_exterior',
              ],
              condition: '(5626) is (interior-color)',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premium-luxury',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        '4pgvkggs0u3k': {
          view: 'exterior',
          groupId: 'premium-luxury-g1',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'EXT_Roof',
              identifiers: [
                'exterior-color',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ROOF',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premium-luxury',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        dbbvufiql40h: {
          view: 'exterior',
          groupId: 'premium-luxury-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'EXT_Black_Roof',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ROOF',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premium-luxury',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        az7g6geux1c1: {
          view: 'exterior',
          groupId: 'sport-g0',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'WO_Seat_Display_Sheer_Gray',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SEAT_SCREEN',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_SEAT_DISPLAY',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'sport',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        '9b2d90cotnka': {
          view: 'interior',
          groupId: 'sport-g0',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_Seat_Display_Sheer_Gray',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_SEAT_SCREEN',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_SEAT_DISPLAY',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'sport',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        '5xqqme5zq02y': {
          view: 'exterior',
          groupId: 'sport-g1',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'EXT_Roof',
              identifiers: [
                'exterior-color',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ROOF',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'sport',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        gorwm4cieo58: {
          view: 'exterior',
          groupId: 'sport-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'EXT_Black_Roof',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ROOF',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'sport',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        wtnujr9hlztg: {
          view: 'exterior',
          groupId: 'premium-sport-g0',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'WO_Executive_Pack_Camelia_Backen',
              identifiers: [
                'common_exterior',
              ],
              condition: '(5640) is (interior-color)',
              isDefault: true,
              isStop: false,
            },
            {
              message: 'WO_Executive_Pack_Harbor_Blue',
              identifiers: [
                'common_exterior',
              ],
              condition: '(5626) is (interior-color)',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premium-sport',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        az7g6geux1c2: {
          view: 'interior',
          groupId: 'premium-sport-g0',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'W_Executive_Pack_Camelia_Backen',
              identifiers: [
                'common_exterior',
              ],
              condition: '(5640) is (interior-color)',
              isDefault: true,
              isStop: false,
            },
            {
              message: 'W_Executive_Pack_Harbor_Blue',
              identifiers: [
                'common_exterior',
              ],
              condition: '(5626) is (interior-color)',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premium-sport',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        quf319yxtxl8: {
          view: 'exterior',
          groupId: 'premium-sport-g1',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'EXT_Roof',
              identifiers: [
                'exterior-color',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ROOF',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premium-sport',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        j2oqomprlsyv: {
          view: 'exterior',
          groupId: 'premium-sport-g1',
          display: true,
          isDefault: false,
          applyMessages: [
            {
              message: 'EXT_Black_Roof',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [
            {
              message: 'CAMERA_ROOF',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          shaderMessages: [
            {
              message: 'SHADER_ROOF',
              identifiers: [
                'common_exterior',
              ],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: [
            'premium-sport',
          ],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
      },
      packages: {},
      interactions: {
        ihmz2ch7lru2: {
          type: 'basic',
          view: [
            'exterior',
            'interior',
          ],
          startMessages: [
            {
              message: 'DOORS_OPEN',
              identifiers: [
                'exterior-color',
                'interior-color',
                'common_interior',
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: 'DOORS_CLOSE',
              identifiers: [
                'exterior-color',
                'interior-color',
                'common_interior',
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'luxury',
          ],
        },
        '53ehrrkf0yxy': {
          type: 'basic',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'interior-color',
                'common_interior',
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'interior-color',
                'common_interior',
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 1.577,
                beta: 1.388,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 1.56,
                beta: 1.583,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'luxury',
          ],
        },
        wn7m7l9dpwjh: {
          type: 'basic',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'SUSPENSION_UP',
              identifiers: [
                'exterior-color',
                'interior-color',
                'common_interior',
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: 'SUSPENSION_DOWN',
              identifiers: [
                'exterior-color',
                'interior-color',
                'common_interior',
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'luxury',
          ],
        },
        zhd8ypjsjml8: {
          type: 'basic-light',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'luxury',
          ],
        },
        qwf8jkzszwpg: {
          type: 'basic-light',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'luxury',
          ],
        },
        n04pf5yhy6ml: {
          type: 'basic-light',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.4358,
                beta: 1.4189,
                radius: 4.581,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'luxury',
          ],
        },
        pdvesjvy4q3c: {
          type: 'basic',
          view: [
            'exterior',
            'interior',
          ],
          startMessages: [
            {
              message: 'DOORS_OPEN',
              identifiers: [
                'exterior-color',
                'interior-color',
                'common_interior',
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: 'DOORS_CLOSE',
              identifiers: [
                'exterior-color',
                'interior-color',
                'common_interior',
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'premium-luxury',
          ],
        },
        tipo90ysous9: {
          type: 'basic',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'interior-color',
                'common_interior',
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'interior-color',
                'common_interior',
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 1.577,
                beta: 1.388,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 1.56,
                beta: 1.583,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'premium-luxury',
          ],
        },
        '9qigkas694ke': {
          type: 'basic',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'SUSPENSION_UP',
              identifiers: [
                'exterior-color',
                'interior-color',
                'common_interior',
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: 'SUSPENSION_DOWN',
              identifiers: [
                'exterior-color',
                'interior-color',
                'common_interior',
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'premium-luxury',
          ],
        },
        zy0w7fsjm17p: {
          type: 'basic-light',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'premium-luxury',
          ],
        },
        k8yumyg89ea4: {
          type: 'basic-light',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'premium-luxury',
          ],
        },
        '004q0jbdcutj': {
          type: 'basic-light',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.4358,
                beta: 1.4189,
                radius: 4.581,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'premium-luxury',
          ],
        },
        nsrbl8k7p41m: {
          type: 'basic',
          view: [
            'exterior',
            'interior',
          ],
          startMessages: [
            {
              message: 'DOORS_OPEN',
              identifiers: [
                'exterior-color',
                'interior-color',
                'common_interior',
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: 'DOORS_CLOSE',
              identifiers: [
                'exterior-color',
                'interior-color',
                'common_interior',
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'sport',
          ],
        },
        q5i2b8dp8qiv: {
          type: 'basic',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'interior-color',
                'common_interior',
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'interior-color',
                'common_interior',
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 1.577,
                beta: 1.388,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 1.56,
                beta: 1.583,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'sport',
          ],
        },
        ca4j5ldx7rcv: {
          type: 'basic',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'SUSPENSION_UP',
              identifiers: [
                'exterior-color',
                'interior-color',
                'common_interior',
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: 'SUSPENSION_DOWN',
              identifiers: [
                'exterior-color',
                'interior-color',
                'common_interior',
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'sport',
          ],
        },
        '0fbm80b2gwrp': {
          type: 'basic-light',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'sport',
          ],
        },
        cuk1rase0zxe: {
          type: 'basic-light',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'sport',
          ],
        },
        pyau4ud8ozn6: {
          type: 'basic-light',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.4358,
                beta: 1.4189,
                radius: 4.581,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'sport',
          ],
        },
        f6mckp6y4528: {
          type: 'basic',
          view: [
            'exterior',
            'interior',
          ],
          startMessages: [
            {
              message: 'DOORS_OPEN',
              identifiers: [
                'exterior-color',
                'interior-color',
                'common_interior',
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: 'DOORS_CLOSE',
              identifiers: [
                'exterior-color',
                'interior-color',
                'common_interior',
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'premium-sport',
          ],
        },
        tbur04pwvnag: {
          type: 'basic',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'interior-color',
                'common_interior',
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'interior-color',
                'common_interior',
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 1.577,
                beta: 1.388,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 1.56,
                beta: 1.583,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'premium-sport',
          ],
        },
        lpgfndx8gmly: {
          type: 'basic',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'SUSPENSION_UP',
              identifiers: [
                'exterior-color',
                'interior-color',
                'common_interior',
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          reverseMessages: [
            {
              message: 'SUSPENSION_DOWN',
              identifiers: [
                'exterior-color',
                'interior-color',
                'common_interior',
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: true,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'premium-sport',
          ],
        },
        bkr8amy2tvbs: {
          type: 'basic-light',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: [
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'premium-sport',
          ],
        },
        '6146uzbd6kui': {
          type: 'basic-light',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: [
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'premium-sport',
          ],
        },
        iq7p37hq4g0j: {
          type: 'basic-light',
          view: [
            'exterior',
          ],
          startMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'TAILLIGHT_GLOW',
              identifiers: [
                'common_exterior',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.4358,
                beta: 1.4189,
                radius: 4.581,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: [
            'premium-sport',
          ],
        },
      },
      hotspots: {
        exteriorCamera: {
          type: 'exterior',
          messages: {
            fov: 0.8,
            alpha: 2.02,
            beta: 1.47,
            radius: 5.7,
            lowerAlphaLimit: null,
            upperAlphaLimit: null,
            lowerBetaLimit: 0.1,
            upperBetaLimit: 1.6,
            lowerRadiusLimit: 3.2,
            upperRadiusLimit: 6.7,
            target: {
              x: 0,
              y: 0.65,
              z: 0,
            },
            isFovZoomModeOn: false,
          },
        },
        interiorCamera: {
          type: 'interior',
          messages: {
            message: 'INT_DEFAULT_CAMERA',
            identifiers: [
              'common_exterior',
            ],
          },
        },
        interiorCamera_1: {
          type: 'interior',
          messages: {
            message: 'INT_DEFAULT_CAMERA_2',
            identifiers: [
              'common_exterior',
            ],
          },
        },
        interiorCamera_2: {
          type: 'interior',
          messages: {
            message: 'INT_DEFAULT_CAMERA_3',
            identifiers: [
              'common_exterior',
            ],
          },
        },
      },
      usdzPathWithVariable: '',
    },
  },
};
